import React, { useContext } from 'react'
import Button from 'react-bootstrap/Button'
import styled from 'styled-components'
import share from 'assets/images/dashboard/share-bg.jpg'
import ShareModal from './ShareModal'
import { getUserEvents } from '../../services/services'
import { JazeelContext } from '../../utils/JazeelContext'

const EarnButton = styled(Button)`
  background: #ffffff url(${share}) top left no-repeat;
  background-size: 2.6em;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  border: none;
  color: #54ce9d;
  padding: 0.6em 1.5em 0.6em 2.5em;
  &:hover {
    color: #367f5d;
    background: #ffffff url(${share}) top left no-repeat;
    background-size: 2.6em;
    padding: 0.6em 1.5em 0.6em 2.5em;
  }
  @media screen and (max-width: 576px) {
    width: 100%;
  }
`

const ShareButtonContainer = styled.div``

export default function ShareButton() {
  const [modalShow, setModalShow] = React.useState(false)
  const { userData, setEvents } = useContext(JazeelContext)

  return (
    <ShareButtonContainer className="float-none float-sm-right float-lg-right float-md-right">
      <EarnButton
        variant="white"
        onClick={() => {
          getUserEvents(userData.email, setEvents)
          setModalShow(true)
        }}
      >
        Share and Earn
      </EarnButton>
      <ShareModal show={modalShow} onHide={() => setModalShow(false)} />
    </ShareButtonContainer>
  )
}
